import React from 'react'
import classes from './LandingPage.module.css'
import { IconButton } from '@material-ui/core'
import { Link } from 'react-router-dom'

const LandingPage = () => {
    return (
        <>
            <section>
                <div className={classes.body1}>

                    <main className={classes.main}>
                        <div className={classes.data}>
                            <h1>Bagels Are Fun</h1>
                            <p>Click Here to try some :)</p>
                        </div>
                        <IconButton component={Link} to="/store" aria-label='store link' color="inherit">
                            <button className={classes.button}>
                                <span>BROWSE</span>
                            </button>
                        </IconButton>
                    </main>
                </div>
            </section>
        </>
    )
}

export default LandingPage;